import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'
import Nprogress from 'nprogress';
import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
    dashBoardData: [],
    recentData: [],
    ticketsData: [],
    ticketConfig: [],
    ticketSLA: [],
    ticketRules: [],
    ticketDetails: [],
}

const mutations = {
    SET_DASHBOARD_DATA(state, data) {
        state.dashBoardData = data;
    },
    RECCENT_ACTIVITIES_DATAS(state, data) {
        state.recentData = data
    },
    ALL_TICKETS_DATA(state, data) {
        state.ticketsData = data
    },
    SET_CONFIG_DATA(state, data) {
        state.ticketConfig = data
    },
    SET_TICKET_SLA_DATA(state, data) {
        state.ticketSLA = data
    },
    SET_TICKET_RULES_DATA(state, data) {
        state.ticketRules = data;
    },
    SET_TICKET_DETAILS_DATA(state, data) {
        state.ticketDetails = data
    },
    DELETE_TICKET(state, data) {
        var ticketId = data.ticketId;
        if (Object.keys(state.ticketsData).length != 0) {
            for (let i = 0; i < ticketId.length; i++) {
                var index = state.ticketsData.allData.findIndex(tickt => tickt.Tickets.id == ticketId[i].id);
                if (index != -1) {
                    state.ticketsData.allData.splice(index, 1);
                }   
            }
        }
    },
    UPDATE_TICKET_LABEL(state, data) {
        var ticketId = data.ticketId;
        var label = data.label;
        if(label == null){
            label = "";
        }
        if (Object.keys(state.ticketsData).length != 0) {
            var index = state.ticketsData.allData.findIndex(tickt => tickt.Tickets.id == ticketId);
            if (index != -1) {
                state.ticketsData.allData[index].Tickets.label = label;
            }   
        }
    },
}

const actions = {
    fetchDashboardHelpdeskDatas({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            Nprogress.start();
            axios.get('/helpdesk/dashboard_list')
                .then(res => {
                    Nprogress.done();
                    if (res.data.status == "redirect") {
                        router.push(res.data.message);
                    } else {
                        commit("SET_DASHBOARD_DATA", res.data)
                        resolve(res.data)
                    }
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status == 403) {
                            window.location = "/dashboard";
                        }
                    }
                })
        })
    },
    getRecentHelpDeskLogs({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            const vueData = true;
            axios
                .post("/helpdesk/data/" + vueData, qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    loader.hide()
                    commit('RECCENT_ACTIVITIES_DATAS', response.data)

                })
                .catch(error => console.log(error));
        });
    },
    fetchTicketsData({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            // let loader = Vue.$loading.show({
            //     canCancel: false,
            // });
            axios
                .post("/helpdesk/all_tickets_data", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    // loader.hide()
                    if (postData.export == true) {
                        if (response.data.status != "success") {
                        reject(response.data.message);
                        return;
                        }
                        window.open("/backend" + response.data.message, "_blank");
                        window.focus();
                        return;
                    }
                    commit('ALL_TICKETS_DATA', response.data)

                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status == 403) {
                            window.location = "/dashboard";
                        }
                    }
                });
        });
    },
    fetchTicketsHistoryData({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/get_ticket_task_admins", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response);
                })
                .catch(error => console.log(error));
        });
    },
    fetchTicketConfigDatas({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.get('/helpdesk/ticket_config_list')
            .then(res => {
                Nprogress.done();
                commit("SET_CONFIG_DATA", res.data)
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status == 403) {
                        window.location = "/dashboard";
                    }
                }
            })
    },
    configEditSubject({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/edit_subject", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response);
                })
                .catch(error => console.log(error));
        });
    },
    configEditPriority({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/edit_priority", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response);
                })
                .catch(error => console.log(error));
        });
    },
    configEditLabel({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/edit_label_name", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response);
                })
                .catch(error => console.log(error));
        });
    },
    saveSubjectInfoDetals({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/submit_info_subject", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    getSubjectInfoDetals({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/get_subject_info_details", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteDetailsTickets({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/delete_subject", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addSubjectTickets({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/add_subject", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addNewLabelTickets({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/add_label_name", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    editOthersTickets({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/edit_others", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteTicketSubject({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/delete_fields", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    newAddField({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/customize_cp", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveResSubjectDetails({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/edit_resolution_subject", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    resSubjectRemove({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/delete_resolution_subject", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addSubjectOneLabel({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/add_resolution_subject", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveAddOnesubject({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/customize_ticket_resolution", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    removeAllsubresolution({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/delete_resolution_fields", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveenableTickets({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/enable_ticket_resolution", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addToSubzoneSave({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/add_ticket_config_subacc", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchTicketSLAData({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.get('/helpdesk/ticket_slas_list')
            .then(res => {
                Nprogress.done();
                commit("SET_TICKET_SLA_DATA", res.data)
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status == 403) {
                        window.location = "/dashboard";
                    }
                }
            })
    },
    saveSLAEmail({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/edit_field/email", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveSLASms({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/edit_field/sms", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteTypeVisibilityAdmin({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/delete_admin_view_type_ticket_settings", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteAssignedAdmin({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/delete_admin_view_assignedall_ticket_settings", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteReopenTicketNotifyAdmin({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/delete_reopen_ticket_notify_admin_settings", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteUnAssignedAdmin({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/delete_admin_view_unassigned_ticket_settings", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addAssignSlaFn({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/admin_view_assignedall_tickets_settings", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addNotifyAdminFn({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/admin_reopen_tickets_notify_settings", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addUnAssignSlaFn({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/admin_view_unassigned_tickets_settings", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addTypeVisibilityForAdmins({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/adminTypeVisible", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveAllDataTicketSla({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios
                .post("/helpdesk/store_sla_values", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    loader.hide()
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addSubAccountTIcketSla({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/add_ticket_sla_to_all_accounts", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchTicketRulesData({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.get('/helpdesk/ticket_rules_list')
            .then(res => {
                Nprogress.done();
                commit("SET_TICKET_RULES_DATA", res.data)
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status == 403) {
                        window.location = "/dashboard";
                    }
                }
            })
    },
    addRulesTicketsPost({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/ticket_rule_settings", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteRulesTicketsPost({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/settings/delete_custom_rule", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addSubAccountTIcketRules({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/add_ticket_rules_to_all_accounts", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    getTicketDetailsData({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.get('/helpdesk/ticket_details_list/' + authData)
            .then(res => {
                Nprogress.done();
                commit("SET_TICKET_DETAILS_DATA", res.data)
            })
            .catch(error => console.log(error))
    },
    saveChangesinTicketDetails({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/change_properties", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    sendMessageTicket({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/send_ticket_message", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    getMessageTicketResolution({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/getAllTicketResolutionSubjects", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    sendcloseticketotp({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/send_close_ticket_otp", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    editVisibleadminsTickets({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/edit_only_visible_for_admin", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    getHeldeskAllSubjectFromTicket({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/getAllSubjects", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteTickets({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/deleteTickets", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    if (response.data.status != "success") {
                        reject(response.data);
                        return;
                    }
                    if(postData.type == 'selected') {
                        var successData = {
                            ticketId: postData.ticketId,
                            // accountId: postData.accountId
                        }
                    } else {
                        var successData = {
                            ticketId: response.data.ticketIds,
                        }
                    }
                    
                    commit("DELETE_TICKET", successData)
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    editTicketLabel({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/helpdesk/editTicketLabel", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    if (response.data.status != "success") {
                        reject(response.data);
                        return;
                    }
                    var successData = {
                        ticketId: postData.ticketId,
                        label: postData.label,
                    }
                    commit("UPDATE_TICKET_LABEL", successData)
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
}

const getters = {
    dashboardListGetters: state => {
        return state.dashBoardData;
    },
    recentDataListGetters: state => {
        return state.recentData;
    },
    ticketsDataListGetters: state => {
        return state.ticketsData;
    },
    ticketsConfigListGetters: state => {
        return state.ticketConfig;
    },
    ticketsSLAListGetters: state => {
        return state.ticketSLA;
    },
    ticketsRulesListGetters: state => {
        return state.ticketRules;
    },
    ticketsDetailsListGetters: state => {
        return state.ticketDetails;
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}
